import React, { useEffect, useState } from 'react';
import { Loader, Modal, Dimmer, Icon } from 'semantic-ui-react';
import { SelectableModalProps } from '../../../../../components/types';
import styled from 'styled-components';
import FollowUpTab from '../Tabs/FollowUpTab';
import ActionHistoryTab from '../Tabs/ActionHistoryTab';

const TabContainer = styled.div`
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 60%;
`;

const TabMenu = styled.div<{ actived: boolean }>`
  width: 50%;
  padding: 8px 12px;
  background-color: ${props => (props.actived ? props.theme.main.color : '#ffffff')};
  color: ${props => (props.actived ? '#ffffff' : props.theme.main.color)};
  cursor: ${props => (props.actived ? '' : 'pointer')};
`;

export type FollowUpModalProps = {
  onClose: () => any;
  onOpen: () => any;
  id: string;
  claim: any;
  isBlocked?: boolean;
  user: any;
} & SelectableModalProps;

type TabeProps = 'follow-up' | 'action-history';

const ClaimUpdatesListModal = (props: FollowUpModalProps) => {
  const { header, onClose, onOpen, isOpen, id, claim, user, isBlocked } = props; // , setUnread, unread
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tabActive, setTabActive] = useState<TabeProps>('follow-up');

  const hasActionHistoryPermission = !user.role.includes('ESTATE');

  const handleDisplay = (hasPermission: boolean) => {
    const classFirstTab = {
      borderRight: '1px solid #dddddd',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px'
    };
    const classLastTab = {
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px'
    };
    const classTabActive = { backgroundColor: '#2185D0', color: '#FFFFFF' };
    const classTabInactive = { cursor: 'pointer' };

    const classTabFollowup =
      tabActive === 'follow-up'
        ? Object.assign({}, classFirstTab, classTabActive)
        : Object.assign({}, classFirstTab, classTabInactive);
    const classTabHistory =
      tabActive === 'action-history'
        ? Object.assign({}, classLastTab, classTabActive)
        : Object.assign({}, classLastTab, classTabInactive);

    return hasPermission ? (
      <>
        <TabContainer>
          <TabMenu
            actived={tabActive === 'follow-up'}
            style={classTabFollowup}
            onClick={() => setTabActive('follow-up')}
          >
            Follow up
          </TabMenu>
          <TabMenu
            actived={tabActive === 'action-history'}
            style={classTabHistory}
            onClick={() => setTabActive('action-history')}
          >
            Histórico de ações
          </TabMenu>
        </TabContainer>

        {tabActive === 'follow-up' ? (
          <FollowUpTab id={id} claim={claim} isBlocked={isBlocked} />
        ) : tabActive === 'action-history' ? (
          <ActionHistoryTab id={id} />
        ) : null}
      </>
    ) : (
      <FollowUpTab id={id} claim={claim} isBlocked={isBlocked} />
    );
  };

  return (
    <>
      <Modal size="large" open={isOpen} onOpen={onOpen} onClose={onClose} closeIcon>
        <Modal.Header>
          {hasActionHistoryPermission ? (
            <>
              <Icon name={tabActive === 'follow-up' ? 'commenting' : 'history'} />{' '}
            </>
          ) : null}
          {header}
        </Modal.Header>
        <Modal.Content>
          {isLoading ? (
            <Dimmer active={isLoading} inverted>
              <Loader content="Carregando mensagens..." />
            </Dimmer>
          ) : (
            handleDisplay(hasActionHistoryPermission)
          )}
        </Modal.Content>
        <Modal.Actions></Modal.Actions>
      </Modal>
    </>
  );
};

export default ClaimUpdatesListModal;
